<template>
  <div class="place-qr-card" :class="{publish: publish}">
    <TitleBar :text="$t('PlaceQRCard.topic')" :showIconButton="false" @clickCloseButton="clickCloseButton" v-if="!publish" />
    <div class="back-space">
      <div class="qr-card-image-container" v-if="util.getUserAgentMeta() === 'iOS browser'">
        <img ref="qrCardImage" src="" v-show="isGeneratedImage">
      </div>
      <div id="qr-card" class="body" ref="qrCard">
        <div class="frame">
          <button class="download-button" @click="download" v-if="!hideDownloadBtn && !publish && !isInLineBrowser">
            <img :src="util.getImagePath('download_blue@2x.png')" :srcset="util.getImageSet('download_blue')">
          </button>
          <div class="logo">
            <img :src="util.getImagePath(`promptpai_logo_${$i18n.locale}@original.png`)">
          </div>
          <div class="line"></div>
          <div class="code">{{ displayId }}</div>
          <div class="qr-group">
            <div class="loading-animation primary" v-show="!isGeneratedQr"></div>
            <vue-qr :text="placeUrl" :size="2100" :margin="0" :callback="callbackGenerateQr" v-show="false"></vue-qr>
            <img class="qr" :src="generatedQrSrc" v-show="isGeneratedQr">
            <img class="logo" :src="util.getImagePath('promptpai_qr_icon@2x.png')" :srcset="util.getImageSet('promptpai_qr_icon')" v-show="isGeneratedQr">
          </div>
          <div class="note">
            {{ $t('PlaceQRCard.scan') }}
          </div>
          <div class="detail">
            <div class="name-primary">
              {{ $i18n.locale === 'th' ? placeDetail.promptpai_name_th : placeDetail.promptpai_name_en }}
            </div>
            <div class="name-secondary">
              {{ $i18n.locale === 'th' ? placeDetail.promptpai_name_en : placeDetail.promptpai_name_th }}
            </div>
            <div class="tel" v-if="'promptpai_telephone' in placeDetail && placeDetail.promptpai_telephone !== ''">
              {{ `${$t('PlaceQRCard.tel')} ` }}
              <span data-nosnippet v-html="`<!--googleoff: all-->${placeDetail.promptpai_telephone}<!--googleon: all-->`"></span>
            </div>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div class="finish-download-message" v-if="isShowFinishDownloadMessage">{{ finishDownloadMessage }}</div>
      </transition>
    </div>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar.vue'
import VueQr from 'vue-qr'
import { setTimeout } from 'timers'

var html2Canvas = require('html2canvas')

export default {
  name: 'PlaceQrCard',
  components: {
    TitleBar,
    VueQr
  },
  props: {
    placeDetail: {
      type: Object,
      default: () => {
        return {}
      }
    },
    publish: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isGeneratedQr: false,
      generatedQrSrc: '',
      hideDownloadBtn: true,
      isGeneratedImage: false,
      finishDownloadMessage: '',
      isShowFinishDownloadMessage: false
    }
  },
  computed: {
    displayId () {
      var self = this
      if (self.placeDetail.promptpai_id) {
        return `${self.placeDetail.promptpai_id.substring(0, 4)} ${self.placeDetail.promptpai_id.substring(4, 8)}`
      } else {
        return ''
      }
    },
    placeUrl () {
      var self = this
      return `${window.location.origin}/p/${self.placeDetail.promptpai_id}`
    },
    isInLineBrowser () {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      if (window.liff) {
        if (userAgent !== 'Android application' && userAgent !== 'iOS application' && process.env.NODE_ENV !== 'development') {
          return window.liff.isInClient()
        }
      }
      return false
    }
  },
  mounted () {
    var self = this
    if (self.placeDetail.promptpai_id) {
      window.gtag('event', 'view_item', {'event_label': `view_place_qr_card_${self.placeDetail.promptpai_id}`})
    }
  },
  methods: {
    clickCloseButton () {
      var self = this
      self.$router.back()
    },
    callbackGenerateQr (data) {
      var self = this
      self.generatedQrSrc = data
      self.isGeneratedQr = true
      setTimeout(() => {
        // console.log('SUCCESS') // for capture with phantom
      }, 1000)
      if (self.util.getUserAgentMeta() !== 'iOS browser') {
        self.hideDownloadBtn = false
      } else {
        self.hideDownloadBtn = true
        setTimeout(() => {
          html2Canvas(self.$refs['qrCard'], {
            scale: 5
          }).then(canvas => {
            var img = self.$refs['qrCardImage']
            img.src = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
            self.hideDownloadBtn = false
            self.isGeneratedImage = true
          })
        }, 30)
      }
    },
    download () {
      var self = this
      self.hideDownloadBtn = true
      setTimeout(() => {
        html2Canvas(self.$refs['qrCard'], {
          scale: 2
        }).then(canvas => {
          var url = `${window.location.origin}/ws/qr/p/${self.placeDetail.promptpai_id}?lang=${self.$i18n.locale}`
          var imageUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
          var base64 = imageUrl.split(',')[1]
          var userAgent = self.util.getUserAgentMeta()
          if (userAgent === 'iOS application') {
            window.saveImageFinished = (error) => {
              if (error !== '' && error !== null && error !== undefined) {
                self.finishDownloadMessage = self.$t('PlaceQRCard.errorSave')
              } else {
                self.finishDownloadMessage = self.$t('PlaceQRCard.successSave')
              }
              self.isShowFinishDownloadMessage = true
              setTimeout(() => {
                self.isShowFinishDownloadMessage = false
              }, 2000)
            }
            // window.location.href = `https://native.saveimage?image=${base64}`
            window.location.href = `https://native.saveimage?url=${encodeURIComponent(url)}`
            // native.capture
          } else if (userAgent === 'Android application') {
            window.blockWriteFile = () => {
              self.finishDownloadMessage = self.$t('PlaceQRCard.blockWrite')
              self.isShowFinishDownloadMessage = true
              setTimeout(() => {
                self.isShowFinishDownloadMessage = false
              }, 2000)
            }
            window.saveImageFinished = (error) => {
              if (error !== '' && error !== null && error !== undefined) {
                self.finishDownloadMessage = self.$t('PlaceQRCard.errorSave')
              } else {
                self.finishDownloadMessage = self.$t('PlaceQRCard.successSave')
              }
              self.isShowFinishDownloadMessage = true
              setTimeout(() => {
                self.isShowFinishDownloadMessage = false
              }, 2000)
            }
            Android.save(base64, `promptpai_${self.placeDetail.promptpai_id}`)
          } else {
            var link = document.createElement('a')
            link.href = imageUrl
            link.download = `promptpai_${self.placeDetail.promptpai_id}.png`
            link.click()

            self.finishDownloadMessage = self.$t('PlaceQRCard.successSave')
            self.isShowFinishDownloadMessage = true
            setTimeout(() => {
              self.isShowFinishDownloadMessage = false
            }, 2000)
          }
          self.hideDownloadBtn = false
        })
      }, 30)
    }
  }
}
</script>

<style scoped>
  .place-qr-card {
    height: fit-content;
    width: 320px;
    height: 480px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    margin-top: auto;
    margin-bottom: auto;
  }

  .qr-card-image-container {
    display: none;
  }

  .body {
    height: 430px;
    padding: 8px;
    box-sizing: border-box;
    background: rgb(255, 255, 255);
  }

  .frame {
    background: rgb(255, 255, 255);
    border: 4px solid rgb(59, 144, 255);
    border-radius: 4px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 8px;
    position: relative;
  }

  button.download-button > img {
    width: 24px;
    height: 24px;
  }

  .logo {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 32px;
  }

  .logo > img {
    height: 32px;
  }

  .line {
    margin: 4px auto;
    width: 180px;
    height: 1px;
    background-color: rgb(227, 227, 227)
  }

  .code {
    width: 180px;
    height: 24px;
    padding-top: 1px;
    font-weight: bold;
    color: rgb(34, 84, 156);
    margin: 16px auto 8px auto;
    box-sizing: border-box;
    border: 1px solid rgb(34, 84, 156);
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  button.download-button {
    padding: 0px;
    border: none;
    background-color: transparent;
    width: 24px;
    height: 24px;
    cursor: pointer;
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .note {
    font-size: 14px;
    text-align: center;
    padding-top: 4px;
  }

  .qr-group {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .qr-group > .qr {
    width: 180px;
    height: 180px;
  }

  .qr-group > .logo {
    position: absolute;
    width: 32px;
    height: 32px;
  }

  .detail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
  }

  .detail > div {
    width: 100%;
    text-align: center;
  }

  .detail > .name-primary {
    font-size: 18px;
    font-weight: bold;
    line-height: 1;
    color: rgb(0, 0, 0);
    font-family: Prompt;
  }

  .detail > .name-secondary {
    font-size: 14px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    font-family: Prompt;
  }

  .detail > .tel > span {
    font-size: 14px;
    font-weight: bold;
    color: rgb(245, 163, 82);
  }

  .detail > .tel {
    padding-top: 8px;
    font-size: 14px;
    font-weight: normal;
    color: rgb(74, 74, 74);
  }

  .finish-download-message {
    position: absolute;
    color: rgb(255, 255, 255);
    background-color: rgb(255, 255, 255, 0.1);
    width: fit-content;
    border-radius: 16px;
    padding: 0px 8px;
    width: max-content;
    height: 32px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 32px;
    left: auto;
    right: auto;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 2s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  @media only screen and (max-width: 768px) {
    .place-qr-card {
      width: 100%;
      min-width: 320px;
      height: 100%;
      border-radius: 0px;
    }

    .back-space {
      width: 100%;
      height: calc(100% - 50px);
      background-color: rgb(0, 0, 0);
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
    }

    .qr-card-image-container {
      display: block;
      height: 430px;
      width: 320px;
      position: absolute;
      z-index: 1;
      top: calc((100% - 430px) / 2);
      left: calc((100% - 320px) / 2);
      background-color: rgb(0, 0, 0);
    }

    .qr-card-image-container > img {
      height: 430px;
      width: 320px;
    }

    .frame {
      height: calc(430px - 8px - 8px);
      width: calc(320px - 8px - 8px);
    }
  }

  .place-qr-card.publish {
    width: 100%;
    min-width: 320px;
    height: 100%;
    border-radius: 0px;
  }

  .publish .back-space {
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .publish .frame {
    height: calc(430px - 8px - 8px);
    width: calc(320px - 8px - 8px);
  }
</style>



// WEBPACK FOOTER //
// src/components/PlaceQrCard.vue